<template>
  <page-wrapper :title="pageWrapper.title" :has-pad="pageWrapper.hasPad">
    <div v-if="!isPermissionCallCenter" class="lead mb-2">
      <router-link :to="allLeadLink" class="link back-page"
        >Lead ทั้งหมด >
      </router-link>
      <router-link :to="leadLink" class="link back-page"
        >{{ lead.name }} >
      </router-link>
      <div class="link name">{{ home.homeNo }}</div>
    </div>
    <div class="grid-contact">
      <div class="lead-Detail">
        <div class="head-datail info">สถานะ Lead :</div>
        <div :class="lead.leadStatusClassList" class="lead-status-badge">
          {{ lead.leadStatusTH }}
        </div>
        <br /><br />
        <div class="head-datail info">ผู้นำเข้า Lead :</div>
        <div class="lead-info">{{ lead.importBy }}</div>
      </div>
      <div>
        <div class="head-datail info">วัน / เวลา เริ่มต้น - สิ้นสุด :</div>
        <div class="lead-info">{{ lead.durationLead }}</div>
        <br /><br />
        <div class="head-datail info">ผู้รับผิดชอบการขาย :</div>
        <div class="lead-info">{{ lead.contactBy }}</div>
      </div>
    </div>
    <div class="grid-home">
      <div class="info-top home">
        <div class="title-head">รายละเอียดบ้าน</div>
        <div class="home-detail">
          <div class="grid-home-no">
            <div>
              <div class="title-home-no">บ้านเลขที่</div>
              <div class="lead">{{ home.homeNo }}</div>
            </div>
            <div class="lead-status">
              <div class="title-home-no">สถานะการใช้งาน</div>
              <div
                :class="home.leadHomeStatusClassList"
                class="lead-text-status-badge"
              >
                {{ home.leadHomeStatusTH }}
              </div>
            </div>
          </div>
        </div>
        <div class="home-detail">
          <div>Home ID : {{ home.homeId }}</div>
          <div>{{ home.projectName }}</div>
          <div class="head-datail">พื้นที่ใช้สอย :</div>
          <div>{{ home.usableArea }}</div>
          <div class="head-datail">อายุบ้าน :</div>
          <div>{{ home.age }}</div>
          <sc-button
            variant="warning"
            class="mt-3"
            @click="handleLinkSubsciptionPurchasedHome()"
            >แพ็คเกจทั้งหมดของบ้าน
          </sc-button>
          <div class="head-datail">แพคเกจปัจจุบัน :</div>
          <div
            v-for="(subscription, index) in activeSubscriptions"
            :key="index"
          >
            <div class="report-cell center">
              - {{ subscription.subscriptionName }}
            </div>
          </div>
        </div>
      </div>
      <div class="info-top customer">
        <div v-if="isEmptyUser" class="no-user-message">ไม่พบข้อมูลลูกค้า</div>
        <div
          v-for="(user, index) in users"
          v-else
          :key="index"
          class="user-row"
        >
          <div v-if="index === 0" class="title-head">
            ผู้ถือกรรมสิทธิ์ {{ usersCount.owner }} คน
          </div>
          <div v-if="residentCountPosition === index" class="title-head">
            ผู้อยู่อาศัย {{ usersCount.resident }} คน
          </div>
          <div v-if="renterCountPosition === index" class="title-head">
            ผู้เช่า {{ usersCount.renter }} คน
          </div>
          <div v-if="otherPosition === index" class="title-head">
            อื่นๆ {{ usersCount.other }} คน
          </div>
          <div :class="user.isSelectedClassList" class="grid-customer">
            <div class="grid-bank">
              <div>
                <input
                  :checked="user.isSelected"
                  class="radio-option"
                  type="radio"
                  name="bank"
                  @change="handleSelectUser(index)"
                />
              </div>
              <img :src="user.image" class="topic-icon" alt />
            </div>
            <div>
              <p class="full-name">{{ user.name }}</p>
              <div class="row">
                <div class="col-6">
                  <label>
                    <span class="head-datail">เบอร์โทร</span>
                    <div>
                      <a
                        v-if="user.mobileNo && user.mobileNo !== '-'"
                        :href="`callto://${user.mobileNo}`"
                        class="callto-link"
                      >
                        {{ user.mobileNo }}
                      </a>
                      <span v-else>-</span>
                    </div>
                  </label>
                </div>
                <div class="col-6">
                  <label>
                    <span class="head-datail">อีเมล</span>
                    <div>{{ user.email }}</div>
                  </label>
                </div>
              </div>
              <div class="mt-2 verify">
                <p class="title">สถานะการยืนยันตัวตน</p>
                <p :class="user.verifyClassList">
                  {{ user.verifyTH }}
                </p>
              </div>
              <div class="mb-3 verify">
                <p class="title">สถานะการเปิด Wallet</p>
                <p :class="user.openWalletClassList">
                  {{ user.openWalletTH }}
                </p>
              </div>
              <label class="mb-2">
                <span class="head-datail">ระบุผลการขาย</span>
                <el-select
                  :value="user.status"
                  :disabled="!user.isSelected || isPermissionManager"
                  class="w-100"
                  @change="handleCurrentChange($event, 'STATUS', index)"
                >
                  <el-option
                    v-for="t in leadHomeStatusMapper"
                    :key="t.value"
                    :label="t.label"
                    :value="t.value"
                  ></el-option>
                </el-select>
              </label>
              <label
                v-if="user.status === leadHomeMapStatus.CAN_NOT_CONTACT"
                class="mb-3"
              >
                <span class="head-datail">เหตุผล</span>
                <el-select
                  :value="user.reason"
                  class="w-100"
                  @change="handleCurrentChange($event, 'REASON', index)"
                >
                  <el-option
                    v-for="(t, reasonIndex) in leadManagementReason"
                    :key="reasonIndex"
                    :label="t.label"
                    :value="t.value"
                  ></el-option>
                </el-select>
              </label>
              <label
                v-if="
                  user.status === leadHomeMapStatus.FOLLOW ||
                  user.status === leadHomeMapStatus.IN_CONTRACT
                "
                class="mb-3"
              >
                <div>
                  <span class="head-datail">{{
                    user.status === leadHomeMapStatus.IN_CONTRACT
                      ? "วันที่หมดสัญญา"
                      : "วันติดต่อลูกค้าอีกครั้ง"
                  }}</span>
                  <el-date-picker
                    :value="user.actionDate"
                    @input="handleCurrentChange($event, 'ACTIONDATE', index)"
                  />
                </div>
              </label>
              <label class="mb-3">
                <span class="head-datail">หมายเหตุ</span>
                <el-input
                  :value="user.remark"
                  :disabled="!user.isSelected || isPermissionManager"
                  class="w-100 input"
                  type="textarea"
                  rows="7"
                  @input="handleCurrentChange($event, 'REMARK', index)"
                ></el-input>
              </label>
            </div>
            <div class="package-detail">
              <label class="mb-3">
                <span class="head-datail">แพ็คเกจที่ต้องการขาย</span>
                <el-select
                  v-model="selectedPackage"
                  :remote-method="handleRemoteMethod"
                  :disabled="
                    !user.isSelected ||
                    isPermissionManager ||
                    user.status !== leadHomeMapStatus.CLOSED
                  "
                  value-key="id"
                  class="w-100"
                  filterable
                  clearable
                  remote
                >
                  <el-option
                    v-for="item in packages"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  ></el-option>
                </el-select>
              </label>
              <label class="mb-3">
                <span class="head-datail">จำนวนการขาย</span>
                <el-input
                  v-model="quantity"
                  :disabled="
                    !user.isSelected ||
                    isPermissionManager ||
                    user.status !== leadHomeMapStatus.CLOSED
                  "
                  class="w-60"
                >
                </el-input>
              </label>
              <div class="mb-3 text-end">
                <sc-button
                  :disabled="
                    !user.isSelected ||
                    isPermissionManager ||
                    user.status !== leadHomeMapStatus.CLOSED
                  "
                  variant="secondary"
                  @click="handleClickAddPackage(index)"
                  >เพิ่มแพ็คเกจ
                </sc-button>
              </div>
              <label class="mb-3">
                <span class="head-datail">รายการแพ็คเกจที่ขาย :</span>
                <div v-for="pack in user.packages" :key="pack.id">
                  {{ pack.packText }}
                </div>
              </label>
              <div v-if="isShowPreviousHistory" class="mt-3 previous-lead">
                <div class="head-previous">
                  <span class="head-datail previous mt-3"
                    >สถานะจาก Lead ที่แล้ว :</span
                  >
                </div>
                <div class="previous-detail">
                  <div class="mb-3">
                    <div class="title-home-no">ชื่อ Lead ที่แล้ว</div>
                    <div>{{ user.previousLeadStatus.leadName }}</div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-6">
                      <div class="title-home-no">วันที่ติดต่อ</div>
                      <div>{{ user.previousLeadStatus.contactDate }}</div>
                    </div>
                    <div class="col-6">
                      <div class="title-home-no">สถานะการขาย</div>
                      <div
                        :class="user.previousLeadStatus.statusClassList"
                        class="lead-status-badge"
                      >
                        {{ user.previousLeadStatus.status }}
                      </div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <div class="title-home-no">ผู้รับผิดชอบการขาย</div>
                    <div>{{ user.previousLeadStatus.admin }}</div>
                  </div>
                  <div class="mb-3">
                    <div class="title-home-no">เหตุผลที่ให้ไว้</div>
                    <div>{{ user.previousLeadStatus.reason }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="contact-history mt-4">
        <lead-contact-history-report
          :home-id="homeId"
          :lead-home-status="leadHomeStatus"
        ></lead-contact-history-report>
      </div>
    </div>
    <div v-if="!isPermissionManager" class="mt-3 text-end">
      <sc-button
        :disabled="canNotSaveStatusNotPending || !isUserSelected"
        variant="warning"
        @click="handleSaveUser()"
        >บันทึก
      </sc-button>
    </div>
  </page-wrapper>
</template>

<script>
import axios from "axios"
import { baanRueJaiClient } from "@/dependencies"
import ScButton from "@/lib/components/ScButton"
import {
  leadHomeManagementStatusENG,
  leadHomeManagementStatusTH,
  leadHomeStatusMapper,
  leadManagementReason,
  leadStatus,
  permissionRole,
} from "@/lib/mapper"

import { DatePicker, Input, Option, Select } from "element-ui"
import { DateTime } from "luxon"

import PageWrapper from "../../../lib/components/PageWrapper"
import LeadContactHistoryReport from "../component/LeadContactHistoryReport"

export default {
  name: "LeadManagementContactPage",
  components: {
    PageWrapper,
    "el-input": Input,
    "el-select": Select,
    "el-option": Option,
    ScButton,
    "el-date-picker": DatePicker,
    LeadContactHistoryReport,
  },
  data() {
    const pageWrapper = {
      title: "รายละเอียด Lead",
      hasPad: true,
    }
    const permission =
      JSON.parse(localStorage.getItem("adminRolePermission")) || null

    return {
      pageWrapper,
      packages: [],
      selectedPackage: null,
      home: {},
      lead: {},
      users: [],
      activeSubscriptions: [],
      defaultUserIcon: "/static/icons/user-profile-default.png",
      quantity: null,
      usersCount: {},
      allLeadLink: { name: "LeadManagementPage" },
      leadLink: {},
      leadId: null,
      isPermissionManager: permission?.role === permissionRole.LMM,
      isPermissionCallCenter: permission?.role === permissionRole.LMC,
      canNotSaveStatusNotPending: false,
      subscriptionPurshasedByHome: { name: "SubscriberListPage" },
      contactHistories: [],
      isShowPreviousHistory: false,
    }
  },
  computed: {
    leadHomeStatusMapper() {
      return leadHomeStatusMapper
    },
    residentCountPosition() {
      return this.usersCount.owner > 0 ? this.usersCount.owner : 0
    },
    renterCountPosition() {
      return this.residentCountPosition + this.usersCount.resident
    },
    otherPosition() {
      return this.renterCountPosition + this.usersCount.renter
    },
    leadHomeMapStatus() {
      return leadHomeManagementStatusENG
    },
    leadManagementReason() {
      return leadManagementReason
    },
    homeId() {
      return this.home && this.home.homeId ? this.home.homeId : null
    },
    leadHomeStatus() {
      return {
        leadHomeStatusLabel: this.lead.leadStatusTH,
        leadHomeStatusValue: this.lead.leadStatusClassList,
      }
    },
    isEmptyUser() {
      return this.users.length === 0
    },
    isUserSelected() {
      return this.users.some((user) => user.isSelected)
    },
  },
  watch: {
    selectedPackage(newValue, oldValue) {
      if (!oldValue && newValue) {
        this.quantity = 1
      } else if (oldValue && !newValue) {
        this.quantity = null
      }
    },
  },
  created() {
    this.setup()
  },
  methods: {
    async setup() {
      await this.setupData()
    },
    async setupData() {
      await Promise.all([this.setupPackages(), this.setupContact()])
    },
    async setupPackages() {
      const result = await this.fetchPackages()

      this.packages = result
    },
    async setupContact() {
      const result = await this.fetchContact()

      this.home = this.setupHomeDetail(result.home)
      this.lead = this.setupLeadDetail(result.lead)
      this.users = await this.setupUsersDetail(result.users)
      this.activeSubscriptions = this.setupActiveSubscription(
        result.active_subscriptions,
      )
      this.usersCount = result.user_role_count

      const selectedUser = this.users.find((user) => user.isSelected)
      this.canNotSaveStatusNotPending =
        selectedUser?.status === leadHomeManagementStatusENG.PENDING
    },
    setupHomeDetail(home) {
      const leadHomeStatusClassList = [home.status]
      const leadHomeStatusTH = leadHomeManagementStatusTH[home.status]
      const usableArea = home.usable_area ? `${home.usable_area} ตร.ม.` : "-"

      const homeDetail = {
        homeId: home.home_id || "-",
        homeNo: home.home_no || "-",
        projectName: home.project_name || "-",
        age: home.age || "-",
        usableArea,
        leadHomeStatusClassList,
        leadHomeStatusTH,
      }

      return homeDetail
    },
    setupLeadDetail(lead) {
      const durationLead =
        lead.start_date && lead.end_date
          ? `${lead.start_date} - ${lead.end_date}`
          : "-"
      const leadStatusClassList = [lead.status]
      const leadStatusTH = leadStatus[lead.status]

      const leadDetail = {
        contactBy: lead.contact_by,
        importBy: lead.import_by,
        durationLead,
        leadStatusClassList,
        leadStatusTH,
        name: lead.name,
      }

      this.leadId = lead.id

      this.leadLink = {
        name: "LeadManagementHomePage",
        params: { id: lead.id },
      }

      return leadDetail
    },
    async setupUsersDetail(users) {
      const userList = await Promise.all(users.map(async (user) => {
        const name = `${user.first_name} ${user.last_name}`
        const isSelected = user.is_selected
        const isSelectedClassList =
          user.is_selected === true ? "SELECTED" : "NOT_SELECT"
        const verifyTH = user.verify === true ? "ยืนยันแล้ว" : "ยังไม่ได้ใช้งาน"
        const verifyClassList =
          user.verify === true ? ["VERIFIED"] : ["NOT_VERIFIED"]
        const openWalletTH =
          user.is_wallet_created === true ? "เปิดแล้ว" : "ยังไม่ได้เปิด"
        const openWalletClassList =
          user.is_wallet_created === true ? ["CREATED"] : ["NOT_CREATED"]

        const packages =
          user.packages.length > 0
            ? user.packages.map((pack) => {
                const packText = `- ${pack.name}(${pack.id}) จำนวน ${pack.quantity} แพ็ค`

                return {
                  id: pack.id,
                  name: pack.name,
                  quantity: pack.quantity,
                  packText,
                }
              })
            : []

        const image = user.image
          ? await this.getImage(user.image)
          : this.defaultUserIcon

        const mobileNo = this.isPermissionCallCenter ? "-" : user.mobile_no

        const previousLead = user.previous_lead_status

        let previousLeadStatus
        if (previousLead) {
          const statusClass = this.leadHomeStatusMapper.find(
            (status) => status.label === previousLead.status,
          )

          previousLeadStatus = {
            admin: previousLead.admin,
            contactDate: previousLead.contact_date,
            leadName: previousLead.lead_name,
            reason: previousLead.reason,
            status: previousLead.status ? previousLead.status : "-",
            statusClassList: [statusClass?.value],
          }
        } else {
          previousLeadStatus = {
            admin: "-",
            contactDate: "-",
            leadName: "-",
            reason: "-",
            status: "user นี้ไม่มีสถานะจาก Lead ที่แล้ว",
            statusClassList: ["FOLLOW"],
          }
        }

        return {
          mobileNo,
          email: user.email || "-",
          status: user.status,
          remark: user.remark,
          role: user.role,
          packages,
          name,
          verifyTH,
          openWalletTH,
          userId: user.user_id,
          image,
          isSelected,
          isSelectedClassList,
          openWalletClassList,
          verifyClassList,
          reason: user.reason || null,
          actionDate: user.action_date || null,
          previousLeadStatus,
        }
      }))

      return userList
    },
    setupActiveSubscription(activeSubscriptions) {
      const activeSubscriptionList = activeSubscriptions.map((subscription) => {
        const subscriptionName = subscription.package_name
        const subscriptionId = subscription.subscription_id

        return {
          subscriptionName,
          subscriptionId,
        }
      })

      return activeSubscriptionList
    },
    async fetchPackages() {
      const response =
        await baanRueJaiClient.admin.subscriptions.recommend_packages.list()

      return response.data.result.packages
    },
    async fetchContact() {
      const { id } = this.$route.params
      const response = await baanRueJaiClient.admin.lead.detailContact(id)

      return response.data.result
    },
    async handleRemoteMethod(queryString) {
      const responses = await Promise.all(
        [1, 2, 3].map((page) =>
          baanRueJaiClient.admin.subscriptions.recommend_packages.list({
            name: queryString,
            page,
          }),
        ),
      )

      this.packages = responses.flatMap(
        (response) => response.data.result.packages,
      )
    },
    async getImage(imageKey) {
      try {
        const resImage = await axios.get(
          `${process.env.HOST}/api/downloads/image`,
          {
            params: {
              imageKey,
            },
          },
        )

        return resImage.data.url
      } catch (_) {
        return null
      }
    },
    handleSelectUser(index) {
      this.users = this.users.map((user, userIndex) => ({
        ...user,
        isSelected: userIndex === index,
        isSelectedClassList: userIndex === index ? "SELECTED" : "NOT_SELECT",
      }))

      const selectedUser = this.users.find((user) => user.isSelected)
      this.canNotSaveStatusNotPending =
        selectedUser?.status === leadHomeManagementStatusENG.PENDING
    },
    handleClickAddPackage(index) {
      if (!this.quantity || this.quantity <= 0) {
        this.$message.error("กรุณาใส่ จำนวนแพ็คเกจ")
        return
      }

      if (!this.selectedPackage) {
        this.$message.error("กรุณาเลือกแพ็คเกจ")
        return
      }

      const packID = this.selectedPackage.id
      const packName = this.selectedPackage.name

      const packText = `- ${packName}(${packID}) จำนวน ${this.quantity} แพ็ค`

      const selectedPackage = {
        id: packID,
        name: packName,
        quantity: this.quantity,
        packText,
      }

      this.users[index].packages.push(selectedPackage)
      this.selectedPackage = null
    },
    handleCurrentChange(value, key, index) {
      const user = this.users[index]

      if (key === "STATUS") {
        user.status = value
        this.canNotSaveStatusNotPending =
          user.status === leadHomeManagementStatusENG.PENDING
        user.reason = null
        user.actionDate = null
      }
      if (key === "REMARK") user.remark = value
      if (key === "REASON") user.reason = value
      if (key === "ACTIONDATE") user.actionDate = value
    },
    async handleSaveUser() {
      const { id } = this.$route.params
      const selectedUser = this.users.find((user) => user.isSelected === true)

      if (
        selectedUser.status === "CLOSED" &&
        selectedUser.packages.length === 0
      ) {
        this.$message.error("หากเลือกสถานะ ปิดงาน ต้องเลือกแพ็คเกจแล้ว")
        return
      }

      const packages = selectedUser.packages.map((pack) => ({
        id: +pack.id,
        name: pack.name,
        quantity: +pack.quantity,
      }))

      const params = {
        lead_home_id: +id,
        selected_package: packages,
        status: selectedUser.status,
        centralize_id: selectedUser.userId,
        note: selectedUser.remark,
        lead_id: this.leadId,
        action_date: selectedUser.actionDate
          ? DateTime.fromJSDate(new Date(selectedUser.actionDate))
              .startOf("day")
              .toUTC()
              .toISO()
          : null,
        reason: selectedUser.reason || null,
      }

      try {
        await this.updateLeadUser(params)
      } catch (error) {
        this.$message.error("ไม่สามารถบันทึกได้ กรุณาลองใหม่อีกครั้ง")
      }
    },
    async updateLeadUser(params) {
      await baanRueJaiClient.admin.lead.update(params)

      this.$message.success("บันทึกเรียบร้อย")
      if (this.isPermissionCallCenter) {
        this.$router.push({ name: "LeadManagementHomeCallCenterPage" })
      } else {
        this.$router.push({
          name: "LeadManagementHomePage",
          params: { id: this.leadId },
        })
      }
    },
    handleLinkSubsciptionPurchasedHome() {
      const { homeId } = this.home
      this.$router.push({ name: "SubscriberListPage", query: { homeId } })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
@import "../lead";

.grid-contact {
  display: grid;
  grid-gap: $space;
  grid-template-columns: 400px auto;
  padding: 15px 10px;

  font-size: 14px;
  font-weight: normal;
}

.grid-home-no {
  display: grid;
  grid-template-columns: 180px auto;
}

.grid-home {
  display: grid;
  grid-template-columns: 400px auto;
}

.lead {
  font-size: 24px;
  font-weight: bold;
}

.head-datail {
  padding-top: 15px;
  font-size: 14px;
  font-weight: bold;

  &.info {
    display: inline;
  }

  &.previous {
    padding: 10px;
  }
}

.previous-lead {
  border: $border;
  border-radius: 3px;
}

.title-head {
  background: #cecdcd 0% 0% no-repeat padding-box;
  border-bottom: 1px solid #d6d6d6;
  opacity: 1;
  height: 58px;
  font-size: 17px;
  font-weight: bold;

  padding: 15px 10px;
}

.lead-status {
  background: #f9f9f9 0% 0% no-repeat padding-box;
  opacity: 1;
  height: 58px;
  border-radius: 10px;

  text-align: center;
}

.home-detail {
  padding: 15px 10px;
}

.package-detail {
  padding-left: 50px;
}

.title-home-no {
  color: #999;
}

.info-top {
  border: 1px solid #d6d6d6;

  &.home {
    border-top-left-radius: $border-radius;
  }

  &.customer {
    border-top-right-radius: $border-radius;
  }
}

.grid-customer {
  display: grid;
  grid-gap: $space;
  grid-template-columns: 100px 300px auto;
  padding: 15px 10px;

  &.NOT_SELECT {
    pointer-events: none;
    background-color: rgb(240, 238, 238);
    opacity: 5;
  }
}

.radio-option {
  pointer-events: auto;
  transform: scale(1.5);
  margin-right: 15px;
  margin-bottom: 10px;
  margin-top: 10px;
  margin-left: 10px;
}

.grid-bank {
  display: grid;
  height: 70px;
  grid-template-columns: 40px 80px;
}

.input > textarea {
  height: 100px;
  width: 295px;
}

.lead-info {
  display: inline;
}

$logoSize: 64px;

.topic-icon {
  width: $logoSize;
  height: $logoSize;
  border-radius: 9px;
  background-color: #eeeeee;
  border: solid 1px $white;
}

.cell {
  font-size: 16px;
}

.user-row {
  border-bottom: $border;
}

.full-name {
  font-size: 18px;
  font-weight: bold;
}

.verify {
  p {
    font-size: 14px;
  }

  > .title {
    font-weight: bold;
  }

  > .VERIFIED,
  .CREATED {
    color: $success-color;
  }

  > .NOT_VERIFIED,
  .NOT_CREATED {
    color: $danger-color;
  }
}

.link {
  display: inline-block;
  opacity: 1;

  &.back-page {
    font-weight: normal;
    color: #999;
    font-size: 20px;
  }

  &.name {
    font-weight: bold;
    font-size: 22px;
  }
}

.head-previous {
  background-color: #f5f7fa;
  height: 40px;
  border-bottom: $border;
}

.previous-detail {
  padding: 10px;
  font-size: 14px;
  font-weight: normal;
}

.no-user-message {
  text-align: center;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.callto-link {
  color: $blue;
  text-decoration: underline;

  &:hover {
    font-weight: bold;
  }
}
</style>
